<template>
  <PostFormAddon
    title="Fotos hochladen"
    :register-wysiwyg-addon="registerWysiwygAddon"
    :icon="mdiImageOutline"
    :badge-count="galleryCount"
    :initial-active="initialShowUploader"
    :registerPostFormAddon="registerPostFormAddon"
    :create-addon-data="createGalleryMedia"
    :update-addon-data="updateGalleryMedia"
    :reset-addon="resetFunction"
  >
    <template v-slot:default="{ resetKey }">
      <div>
        <GalleryUploader
          :key="resetKey"
          @valid="$emit('valid', $event)"
          @uploads="setGalleryUploads"
          @deleteExisting="deleteGalleryMedium"
          :existing-gallery-media="existingGalleryMedia"
          :only-images="true"
        />
        <div class="d-flex flex-column align-center">
          <v-progress-circular
            color="primary"
            class="mt-8 mb-8"
            v-if="existingGalleryMediaLoading"
            indeterminate
            size="64"
          />
        </div>
      </div>
    </template>
  </PostFormAddon>
</template>

<script lang="ts">
import { defineComponent, PropType, toRef } from "vue"
import { RegisterWysiwygAddonFunction } from "features/wysiwyg/addon/wysiwyg-addon.types"
import { RegisterPostFormAddonFunction } from "features/posts/form/addon/post-form-addon.types"
import { Post } from "suus-api"
import PostFormAddon from "features/posts/form/addon/PostFormAddon.vue"
import GalleryUploader from "features/gallery/uploader/GalleryUploader.vue"
import { mdiImageOutline } from "@mdi/js"
import { useGalleryAddon } from "features/posts/form/gallery/gallery-addon.concern"
import { deleteGalleryMedium } from "features/posts/form/gallery/gallery.functions"
import { DeletePostFunction } from "features/posts/form/post-form.types"

/**
 * TODO: Remove the PostFormAddon, inline the functionality here
         It's overengineered and not needed.
 */

export default defineComponent({
  name: "GalleryAddon",
  components: { GalleryUploader, PostFormAddon },
  props: {
    registerWysiwygAddon: {
      type: Function as PropType<RegisterWysiwygAddonFunction>,
      required: true,
    },
    registerPostFormAddon: {
      type: Function as PropType<RegisterPostFormAddonFunction>,
      required: true,
    },
    post: {
      type: Object as PropType<Post>,
    },
    deletePost: {
      type: Function as PropType<DeletePostFunction>,
      required: false,
    },
    initialShowUploader: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    valid: (valid: boolean) => true,
  },
  setup(props) {
    const post = toRef(props, "post")

    const {
      galleryCount,
      createGalleryMedia,
      updateGalleryMedia,
      setGalleryUploads,
      existingGalleryMedia,
      resetFunction,
      existingGalleryMediaLoading,
      loadAllExistingGalleryMedia,
      removeExistingGalleryMedia,
    } = useGalleryAddon(post, props.deletePost)

    loadAllExistingGalleryMedia()

    const _deleteGalleryMedium = async (mediumId: number) => {
      await deleteGalleryMedium(mediumId)
      removeExistingGalleryMedia(mediumId)
    }

    return {
      mdiImageOutline,
      galleryCount,
      createGalleryMedia,
      updateGalleryMedia,
      existingGalleryMedia,
      setGalleryUploads,
      resetFunction,
      deleteGalleryMedium: _deleteGalleryMedium,
      existingGalleryMediaLoading,
    }
  },
})
</script>
